import { useLogin } from "../login/context/LoginContext";

import { Button, Text } from '@ui-component-library';

import LoginStart from './content/start';
import LoginBankid from './content/bankid';
import LoginCode from './content/code';
import LoginMain from './content/main';

import TreebulaLogo from '@assets/treebula/logo.svg';
import TreebulaLogoIcon from '@assets/treebula/icon.svg';

export default function LoginPopup({children}) {
    const LoginContext = useLogin();
    const handleLogoClick = (e) => {
        if(window.location.pathname == '/') {
            LoginContext.close(false)
        } else {
            window.open('/', '_self')
        }
    }

    return <>
        {LoginContext.show && <>
            <div
                className="flex flex-col fixed inset-0 w-screen h-svh bg-white"
                style={{ zIndex: 10000 }}
            >
                <header className="flex h-16 shrink-0 items-center justify-between px-8 py-4">
                    <TreebulaLogo
                        width="132px"
                        height="21px"
                        className="hidden md:block cursor-pointer"
                        onClick={handleLogoClick}
                    />
                    <TreebulaLogoIcon
                        width="52px"
                        height="21px"
                        className="md:hidden cursor-pointer"
                        onClick={handleLogoClick}
                    />

                    <Button variant="secondary" onClick={() => LoginContext.close(false)}>
                        Stäng
                    </Button>
                </header>

                <div className="grid min-h-0 flex-1 grid-cols-1 gap-4 px-4 pb-4 md:grid-cols-[minmax(0,1fr)_464px] md:grid-rows-[minmax(0,1fr)]">
                    <div className="relative hidden min-h-0 overflow-hidden rounded-3xl md:block">
                        <img
                            src={`${Window.static_path}img/other/containerlogin.webp`}
                            alt=""
                            className="absolute inset-0 size-full object-cover"
                        />
                        <div
                            aria-hidden
                            className="pointer-events-none absolute inset-0 mix-blend-darken"
                        />
                        <Text
                            variant="text-7xl/leading-normal/medium"
                            className="absolute top-[76px] left-1/2 w-[400px] -translate-x-1/2 text-center text-spring-yellow-500"
                        >
                            Framtidens skogsägande börjar här.
                        </Text>
                    </div>

                    <div className="flex min-h-0 w-full flex-col items-center justify-start md:min-h-[480px] md:justify-center md:rounded-3xl md:bg-[#F6F3EE] md:px-6 md:py-4">
                        <div className="w-full max-w-[416px]">
                            {LoginContext.view == 'start' && <LoginStart />}
                            {LoginContext.view == 'bankid' && <LoginBankid />}
                            {LoginContext.view == 'code' && <LoginCode />}
                            {LoginContext.view == 'main' && <LoginMain />}
                        </div>
                    </div>
                </div>
            </div>
        </>}

        {children}
    </>
}
